import { Component, OnInit, Inject } from "@angular/core";

import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { MarkManagementService } from "src/app/services/http/business/markManagement/mark-management.service";
import { EducationPackageService } from "src/app/services/http/business/educationPackage/education-package.service";
import { IEducationPackage } from "src/app/interfaces/educationPackage";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-mark-classification-entry',
  templateUrl: './mark-classification-entry.component.html',
  styleUrls: ['./mark-classification-entry.component.css']
})
export class MarkClassificationEntryComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  isOwner: boolean;
  cCode: string;
  errors = new Array();
  eduPackageList: IEducationPackage;
  typeComboList: any;

  constructor(
    private fb: FormBuilder,
     private snackBar: SnackBarService,
    public translate: TranslateService,
    private eduPackageService: EducationPackageService,
    private errorService: ErrorsService,
    private markManagementService: MarkManagementService,
    private dialogRef: MatDialogRef<MarkClassificationEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) {}

  ngOnInit() {
    this.createForm();
    this.getTypeComboList();
    this.getEduPackage();
  }

  createForm() {
   
    this.form = this.fb.group({
      MarkClassificationTypeId: [
        this.data.IsUpdate ? this.data.MarkClassificationTypeId : null,
        Validators.compose([Validators.required])
      ],
      PackageId: [
        this.data.IsUpdate ? this.data.PackageId : null,
        Validators.compose([Validators.required])
      ],
      
      IsActive: [
        this.data.IsUpdate? this.data.IsActive: true
      ],
      //Validators.pattern('/name/'))
      MaxMark: [
        this.data.IsUpdate ? this.data.MaxMark :0,
          Validators.compose([
            Validators.required,
           Validators.min(0),
           // Validators.pattern(
              // `^[${this.form.value.MinMark}-9]|[1-${this.form.value.MinMark}][0-9]|1[0-0]`),
             // `^[${this.form.value.MinMark}-9]|[1-${this.form.value.MinMark}][0-9]|1[0-0]`),
           Validators.max(100)
          ])
      ],
      MinMark: [
        this.data.IsUpdate ? this.data.MinMark :0,
        Validators.compose([
          Validators.required,
          Validators.min(0),
          Validators.max(100)
        ])
    ]
    });
  }

  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        
        this.eduPackageList = res.DataList;
      },
      err => {
        console.log(err);
      }
    );
  }

  getTypeComboList() {
    this.markManagementService.typeComboList().subscribe(
      res => {
       
        this.typeComboList = res;
      },
      err => {
        console.log(err);
      }
    );
  }

  onNoClick() {
    this.dialogRef.close();
  }

  submit(form: any) {
   
    this.errors = new Array();
    let command={
      "PackageId": form.PackageId,
      "Id": this.data.IsUpdate?this.data.Id:0,
      "MarkClassificationTypeId": form.MarkClassificationTypeId,
      "MinMark": form.MinMark,
      "MaxMark": form.MaxMark,
      "ContainMin": true,
      "ContainMax": false,
      "IsActive": form.IsActive
    }
    
    if (this.data.IsUpdate == false) {
      this.markManagementService.markClassificationAdd(command).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.markClassification", { name: this.translate.get('label.submit') }),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.onNoClick();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
    if (this.data.IsUpdate) {
      form.Id = this.data.Id;
      this.markManagementService.markClassificationEdit(command).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.markClassification", { name: this.translate.get('label.edit') }),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close(form);
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
  }
}
